export default __webpack_public_path__ + "static/media/dideban1.ce726c26.jpg";